import axios from "axios";

const BASE_URL = "https://banglacalender.in/api";

const handleUserSignUp = async (userRegisterData) => {
  try {
    const response = await axios.post(`${BASE_URL}/register`, {
      f_name: userRegisterData.firsName,
      m_name: null,
      l_name: userRegisterData.lastName,
      email: userRegisterData.email,
      password: userRegisterData.password,
      phone: userRegisterData.phone,
    });

    console.log("Signup Success:", response.data);
    return response;
  } catch (error) {
    
      console.error("Signup Error (Server):", error.response.data);
      throw  error ;
      
    
  }
};

const handleUserLoggedIn = async ({email,password}) => {
  try {


    const resUserloggIn= await axios.post(`${BASE_URL}/login`,{
        email,
        password,
        
    })

    // console.log("resUserloggIn: ",resUserloggIn);
    return resUserloggIn;
    


  } catch (error) {
    
      console.error("Login Error (Server):", error.response.data.message);
      throw error.response.data.message;
   
  }
};


const handleUserOtprequest=async(phoneNumber)=>{
    try {
        const resUserOtpReq= await axios.post(`${BASE_URL}/login/otp/request`,{
            phone:phoneNumber,
        })

        console.log("resUserOtpReq: ",resUserOtpReq);
        

        return resUserOtpReq;
        
    } catch (error) {
  if (error.response) {
    // Server responded but with error (4xx or 5xx)
    console.error("OTP Request Error (Server):", error.response.data);
    throw new Error(error.response.data.message || "Failed to request OTP from server");
  } else if (error.request) {
    // Request was sent but no response received
    console.error("OTP Request Error (Network):", error.request);
    throw new Error("No response from server. Please check your internet connection.");
  } else {
    // Something else went wrong
    console.error("OTP Request Error:", error.message);
    throw new Error("Unexpected error occurred while requesting OTP");
  }
}

}

const handleUserOtpVerify= async({phone,code})=>{
    try {
        const resUserVerify= await axios.post(`${BASE_URL}/login/otp/verify`,{
            phone,
            code,
        })

        console.log("resUserVerify: ",resUserVerify);
        

        return resUserVerify;
   } catch (error) {
  if (error.response) {
    // Backend responded with an error status (4xx / 5xx)
    console.error("OTP Verify Error (Server):", error.response.data);
    throw new Error(error.response.data.message || "Failed to verify OTP");
  } else if (error.request) {
    // Request sent but no response received
    console.error("OTP Verify Error (Network):", error.request);
    throw new Error("No response from server. Please check your internet connection.");
  } else {
    // Other unexpected errors
    console.error("OTP Verify Error:", error.message);
    throw new Error("Unexpected error occurred during OTP verification");
  }
}

}


export {
     handleUserSignUp,
    handleUserLoggedIn,
    handleUserOtprequest,
    handleUserOtpVerify
 };
